import React from 'react';

//import img
import cardsImg from '../assets/icons/cards.svg';

import event from '../assets/icons/event.svg';
import eventSeries from '../assets/icons/event-series.svg';
import work from '../assets/icons/work.svg';
import journal from '../assets/icons/journal.svg';
import journalNumber from '../assets/icons/journal-number.svg';
import institution from '../assets/icons/institution.svg';
import series from '../assets/icons/series.svg';
import person from '../assets/icons/person.svg';

const PageHeader = ({ name, type }) => {
    const getImg = (type) => {
        switch (type) {
            case 'person':
                return person;
            case 'series':
                return series;
            case 'event-series':
                return eventSeries;
            case 'event':
                return event;
            case 'institution':
                return institution;
            case 'creative-work':
                return work;
            case 'journal':
                return journal;
            case 'journal-number':
                return journalNumber;
            default:
                return;
        }
    };
    return (
        <div className="page-header__container">
            <h3 className="page-header">
                {type && <img src={getImg(type)} alt="" className="card__main-header__img"/>}
                {/* {!type && <img src={cardsImg} alt="" className="card__main-header__img"/>} */}
                {name}
            </h3>
        </div>
    );
};

export default PageHeader;



// WEBPACK FOOTER //
// ./src/components/PageHeader.js